import { generatePuzzle, type Difficulty } from './generator';
import type { Board } from './board';

export type GeneratorRequest = {
  type: 'generate';
  requestId: number;
  difficulty: Difficulty;
  seed: number;
};

export type GeneratorResponse =
  | {
      type: 'generated';
      requestId: number;
      difficulty: Difficulty;
      seed: number;
      puzzle: Board;
    }
  | {
      type: 'failed';
      requestId: number;
      reason: 'attempt-limit' | 'invalid-seed';
    };

export function handleGeneratorRequest(
  request: GeneratorRequest,
  respond: (response: GeneratorResponse) => void,
): void {
  if (!Number.isSafeInteger(request.seed)) {
    respond({ type: 'failed', requestId: request.requestId, reason: 'invalid-seed' });
    return;
  }

  try {
    const generated = generatePuzzle(request.difficulty, request.seed);
    if (generated.ok) {
      respond({
        type: 'generated',
        requestId: request.requestId,
        difficulty: generated.difficulty,
        seed: generated.seed,
        puzzle: generated.puzzle,
      });
    } else {
      respond({
        type: 'failed',
        requestId: request.requestId,
        reason: generated.reason,
      });
    }
  } catch {
    respond({
      type: 'failed',
      requestId: request.requestId,
      reason: 'attempt-limit',
    });
  }
}
